import { cn } from '@kidshome/ui';

/**
 * Renders a registry "concept" icon: the art SVG when present, else the emoji glyph fallback. The single
 * render primitive for the status / economy / history registries (HISTORY_CONCEPT, METRIC_GLYPH,
 * SOURCE_GLYPH, TIME_GLYPHS) — so art and emoji are swapped in ONE place and every surface stays consistent.
 * `size` (px) sizes the art box; the emoji uses ~0.82× as its font-size so the two read at the same scale.
 * Decorative (the row's label carries meaning), so `aria-hidden`.
 */
export function ConceptIcon({
  art,
  glyph,
  size = 24,
  className,
}: {
  /** The concept art URL (from the single concept-art source), or undefined to show the emoji. */
  art?: string;
  /** The emoji fallback (always set, so an unmapped/missing art still renders). */
  glyph: string;
  /** Box size in px — the art fills it; the emoji renders at ~0.82× so both match. Default 24. */
  size?: number;
  className?: string;
}): React.ReactElement {
  if (art) {
    return (
      <img
        src={art}
        alt=""
        aria-hidden="true"
        width={size}
        height={size}
        className={cn('object-contain', className)}
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      className={className}
      style={{ fontSize: Math.round(size * 0.82), lineHeight: 1 }}
    >
      {glyph}
    </span>
  );
}
